import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class StreamService {

  alertChannel: Subject<any> = new Subject();
  alertSubscription$ = this.alertChannel.asObservable();
  streamMessage(data: any) {
    let obj = {data:data}
    this.alertChannel.next(obj);
  }

  getSubscription(): Observable<any> {
    return this.alertSubscription$;
  }

  //for filter
  alertFilter: BehaviorSubject<any> =new BehaviorSubject(new Array<any>());;
  alertFilterSubscription$ = this.alertFilter.asObservable();
  streamFilterMessage(data: any) {
    let obj = data;
    this.alertFilter.next(obj);
  }

  getFilterSubscription(): Observable<any> {
    return this.alertFilterSubscription$;
  }




  // Observable string sources
  private emitChangeSource = new Subject<any>();
  // Observable string streams
  changeEmitted$ = this.emitChangeSource.asObservable();
  // Service message commands
  emitChange(change: any) {
      this.emitChangeSource.next(change);
  }


  private realoadNoti = new Subject<any>();
  realoadNotification(change: any) {
    this.realoadNoti.next(change);
}
changeNotif$ = this.realoadNoti.asObservable();


}
